<template>
    <transition name="fade">
        <div
            v-show="visible"
            :class="{drawer: true, visible: visible}"
            @click="$emit('update:visible', false)"
        >
            <div class="panel" @click.stop>
                <slot></slot>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style>
@keyframes drawer-in {
    0% {
        transform: translate(-100%, 0px);
    }
    100% {
        transform: translate(0px, 0px);
    }
}

@keyframes drawer-out {
    0% {
        transform: translate(0px, 0px);
    }
    100% {
        transform: translate(-100%, 0px);
    }
}
</style>

<style lang="less" scoped>

.drawer {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 100;

    &.visible .panel{
        animation: drawer-in .3s;
    }
    .panel {
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 240px;
        background-color: rgba(36, 40, 39, 1);
        box-shadow: 16px 0 6px rgba(0, 0, 0, 0.25);
        animation: drawer-out .3s;
    }
}

</style>
